import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const TiltLion = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-18, 18]), { stiffness: 120, damping: 14 });
  const tx = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 80, damping: 16 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div onMouseMove={onMove} onMouseLeave={reset} data-testid="hero-lion-tilt" className="relative aspect-square w-full [perspective:1000px]">
      <svg viewBox="0 0 200 200" className="spin-slow absolute inset-0 h-full w-full" aria-hidden>
        <defs><path id="circ" d="M100,100 m-86,0 a86,86 0 1,1 172,0 a86,86 0 1,1 -172,0" /></defs>
        <text className="font-mono-label" fontSize="9.5" letterSpacing="4.2" fill="#0A0A0A">
          <textPath href="#circ">CRESWAY MEDIA ✶ UPDATES ✶ ANNOUNCEMENTS ✶ NEWS ✶</textPath>
        </text>
      </svg>
      <motion.div initial={{ opacity: 0, scale: 0.6, rotate: -12 }} animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ delay: 0.5, duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        style={{ rotateX: rx, rotateY: ry, x: tx, transformStyle: "preserve-3d" }} className="absolute inset-[16%]">
        <div className="absolute inset-[8%] rounded-full bg-[#E62314]/10 blur-2xl" />
        <img src="/assets/logo.png" alt="Cresway Media lion mascot" style={{ transform: "translateZ(60px)" }}
          className="relative h-full w-full object-contain drop-shadow-[0_30px_40px_rgba(10,10,10,0.25)]" />
      </motion.div>
    </div>
  );
};
